module.exports = __webpack_public_path__ + "img/wx.4448e816.png";